import React from "react";
import TitleCompanyListTable from "./TitleCompanyListTable";
const columns = [
  {
    key: 1,
    id: "no",
    disablePadding: true,
    label: "No.",
    minWidth: 50,
  },
  {
    key: 2,
    id: "profile",
    disablePadding: true,
    label: "Profile",
    minWidth: 115,
  },
  {
    key: 3,
    id: "admin_name",
    disablePadding: true,
    label: "Admin",
    minWidth: 115,
  },
  {
    key: 4,
    id: "email",
    disablePadding: true,
    label: "Email",
    minWidth: 115,
  },
  //   {
  //     key: 5,
  //     id: "phone",
  //     disablePadding: true,
  //     label: "Phone",
  //     sorting: true,
  //     minWidth: 80,
  //   },
  {
    key: 6,
    id: "created_at",
    disablePadding: true,
    label: "Created",
    // sorting: true,
    minWidth: 115,
  },

  {
    key: 7,
    id: "updated_at",
    disablePadding: true,
    label: "Modified",
    // sorting: true,
    minWidth: 115,
  },
  {
    key: 8,
    id: "setting",
    disablePadding: true,
    label: "Action",
    minWidth: 20,
  },
];

const InternalAdminComponent = ({ broker_data }) => {
  return (
    <>
      <TitleCompanyListTable
        isInternalAdmin={true}
        columns={columns}
        selectedRow={broker_data}
      />
    </>
  );
};

export default InternalAdminComponent;
